<template>
	<div class="md-layout">
		<simple-datatable
			title="Liste des activités"
			:add="add"
			editRoute="Edit Activity"
			:data="activities"
			:footer="['#', 'Nom', '']"
			:searchFields="['id', 'name']"
			defaultSort="id"
		></simple-datatable>
	</div>
</template>

<script>
import SimpleDatatable from "@/pages/Configuration/components/SimpleDatatable";

export default {
	name: "Activities",
	components: {
		SimpleDatatable
	},
	data() {
		return {
			activities: [],
			add: {
				text: "Ajouter une activité",
				route: "Add Activity"
			},
		}
	},
	async mounted() {
		let { data } = await this.$store.dispatch('activities/getActivites')
		// Trie de base par l'attribue "name"
		this.activities = data.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
	}
}
</script>

<style scoped>

</style>
